import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

export const userManager = new UserManager({
  authority: process.env.REACT_APP_OAUTH_AUTHORITY ?? '',
  client_id: process.env.REACT_APP_OAUTH_CLIENT_ID ?? '',
  redirect_uri: window.location.origin + '/callback',
  // silent_redirect_uri: window.location.origin + '/callback',
  scope: 'openid profile email',
  post_logout_redirect_uri: window.location.origin,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  monitorSession: true,
})
